var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"role":"img"}},[_vm._v(" mdiSvg-xxx ")])
}
var staticRenderFns = []

export { render, staticRenderFns }